<script>
import {mapState} from "vuex";
import _ from "lodash";

export default {
  name: "CardViewingComment",
  props: {
    select_comment: {
      type: Object
    }
  },
  data: () => ({

  }),
  computed: {
    current_provision_status() {
      return this.select_comment.data_result?.provision_status
    },
    current_access_status() {
      return this.select_comment.data_result?.access_status
    },
    current_addit_message() {
      return this.select_comment.addit_message
    },
  },
  methods: {
    setIndexWindowListComments(){
      this.$emit('setIndexWindowListComments')
    }
  }
}
</script>

<template>
  <v-card  elevation="0">
    <v-card-title style="width: 100%">
      <v-btn icon @click="setIndexWindowListComments">
        <v-icon size="15px">
          fa-chevron-left
        </v-icon>
      </v-btn>
      Комментарий
    </v-card-title>

    <v-divider/>

    <v-card-text style="height: calc(100% - 150px);">
<!--      <v-row justify="center">-->
<!--        <v-col cols="6">-->
<!--          <v-text-field-->
<!--              :value="current_provision_status"-->
<!--              label="Обеспечивание учебного процесса"-->
<!--              no-data-text="Данные отсутствуют"-->
<!--              readonly-->
<!--              dense-->
<!--              hide-details-->
<!--              rounded-->
<!--              outlined-->
<!--          ></v-text-field>-->
<!--        </v-col>-->
<!--        <v-col cols="6">-->
<!--          <v-text-field-->
<!--              :value="current_access_status"-->
<!--              no-data-text="Данные отсутствуют"-->
<!--              label="Размещение в СДО Moodle"-->
<!--              readonly-->
<!--              dense-->
<!--              hide-details-->
<!--              rounded-->
<!--              outlined-->
<!--          ></v-text-field>-->
<!--        </v-col>-->
<!--      </v-row>-->
      <v-textarea
          class="mt-5 rounded-xl"
          :value="current_addit_message"
          readonly
          outlined
          label="Поле для комментария"
      ></v-textarea>
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>